import React from 'react'
import DeleteConfirmationDailog from '../../utils/confirmDeletion';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useEffect } from 'react';
import { StudentTransferLogShowdata } from '../../services/LoginPageService';

const StudentTransferLog = () => {
  const [rows,setRow]=useState([]);
  const [isLoading, setGridLoading] = useState(true);
  const [refreshData, setRefreshData] = useState(false);
  const [deleteId,setDeleteId]=useState('');
  const [deleteDailogOpen,setDeleteDailogOpen]= useState(false);
  
  const columns = [
    {
      field: 'studentId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Campus Id',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'registrationNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Registration No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'studentName',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'location',
      headerClassName: 'super-app-theme--header',
      headerName: 'Location',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'branch',
      headerClassName: 'super-app-theme--header',
      headerName: 'Hostel Name',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'specialization',
      headerClassName: 'super-app-theme--header',
      headerName: 'Specialization',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'semester',
      headerClassName: 'super-app-theme--header',
      headerName: 'Semester',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'section',
      headerClassName: 'super-app-theme--header',
      headerName: 'Section',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'gender',
      headerClassName: 'super-app-theme--header',
      headerName: 'Gender',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'studentContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Student Contact No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'emailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'parentsNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'parentsEmailId',
      headerClassName: 'super-app-theme--header',
      headerName: 'Parents Email Id',
      minWidth: 100, flex: 1, align: 'left', headerAlign: 'center'
    },
    {
      field: 'altContactNo',
      headerClassName: 'super-app-theme--header',
      headerName: 'Alternate No',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
    {
      field: 'rfid',
      headerClassName: 'super-app-theme--header',
      headerName: 'RFID',
      minWidth: 100, flex: 1, align: 'center', headerAlign: 'center'
    },
  ];

  useEffect(()=>{
    StudentTransferLogShowdata(handleTransferLogShow,handeTransferLogException);
  },[refreshData])
  
  const handleTransferLogShow=(dataObject)=>{
    setGridLoading(false);
    setRow(dataObject?.data || []);
  }

  const handeTransferLogException=(errorStatus, errorMessage)=>{
    console.log(errorMessage);
  }
 
  return (
    <div>
      <DeleteConfirmationDailog
        open={deleteDailogOpen}
        setOpen={setDeleteDailogOpen}
        deleteId={deleteId}
      />
      
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={8}
        loading={isLoading} 
        rowsPerPageOptions={[8]}
        disableSelectionOnClick
        sx={{
        height: '500px',
        width: '100%',
        '& .super-app-theme--header': {
            WebkitTextStrokeWidth:'0.6px',
        },
        }}
      />
    </div>
  )
}

export default StudentTransferLog
